/**
 * Puzzle iframe URL construction, ported from legacy puzzle.js. External puzzle
 * filepaths (e.g. "/puzzle/p1.html?id=16a") are resolved under the show's
 * payload dir and stamped with the group id + user id the iframe expects.
 */

function setParam(url: string, key: string, value: string): string {
  const [path, query = ""] = url.split("?");
  const params = new URLSearchParams(query);
  params.set(key, value);
  return `${path}?${params.toString()}`;
}

export function externalPuzzleUrl(
  themeId: string,
  filepath: string,
  groupId: string,
  userId: string,
): string {
  let url = `/api/load_puzzle/${themeId}/files${filepath}`;
  url = setParam(url, "uid", groupId);
  url = setParam(url, "user_uuid", userId);
  return url;
}

export function defaultPuzzleUrl(themeId: string): string {
  return `/api/load_puzzle/${themeId}/files/puzzle/default.html`;
}

export function secondaryDefaultPuzzleUrl(themeId: string): string {
  return `/api/load_puzzle/${themeId}/files/puzzle/secondary-default.html`;
}
